export default __webpack_public_path__ + "static/media/526.261ec382.png";